import React, { useState } from 'react';
import { SelectHourData } from '../../../../../data/SelectHourData';
import { computeDateHour, getDayJsFromIso } from '../../../../../utils/date';

function SelectHour(props) {
	// useState pour ajouter ou supprimer la classe selected
	const [selectedHour, setSelectedHour] = useState(-1);

	function getClass(index, isAvailable) {
		let classes = 'pick-hour';

		if (selectedHour === index) {
			classes += ' selected';
		}

		if (!isAvailable) classes += ' unavailable';

		return classes;
	}

	// On parse les trings vers un int pour mettre a jour les h et les minutes
	function onClickHour(index, isAvailable) {
		if (!isAvailable) {
			return;
		}

		setSelectedHour(index);

		const splitHour = SelectHourData[index].split(':');
		const computedHour = computeDateHour(
			props.isoDate,
			parseInt(splitHour[0]),
			parseInt(splitHour[1])
		);

		props.setSelectedDate(computedHour);
	}

	// Fonction qui permet d'affichier les crenaux
	function displayHour() {
		const arrayHour = [];

		for (let index = 0; index < SelectHourData.length; index++) {
			const isHourAvailable = IsHourAvailable(SelectHourData[index]);
			arrayHour.push(
				<div
					className={getClass(index, isHourAvailable)}
					onClick={() => onClickHour(index, isHourAvailable)}
					key={index + 'hour'}
				>
					<span className="hour-content">{SelectHourData[index]}</span>
				</div>
			);
		}

		return arrayHour;
	}

	function IsHourAvailable(stringHour) {
		let isAvailable = true;

		props.rdvs.forEach((rdv) => {
			const rdvDayJs = getDayJsFromIso(rdv);
			const splitHour = stringHour.split(':');
			let isoDateDayJs = getDayJsFromIso(props.isoDate);

			isoDateDayJs = computeDateHour(
				isoDateDayJs,
				parseInt(splitHour[0]),
				parseInt(splitHour[1])
			);

			// check if the date are the same (check year, month, day, hour, minute)
			if (rdvDayJs.isSame(isoDateDayJs, 'minute')) isAvailable = false;
		});

		return isAvailable;
	}

	return <div className="display-hour-container">{displayHour()}</div>;
}

export default SelectHour;
